import { array, number, object, string } from "yup";
import { LeaderboardStepsUnion } from "./LeaderboardForm";

export const getValidationSchemaByStep = (
  activeStep: LeaderboardStepsUnion,
  message: any,
) => {
  switch (activeStep) {
    case "info":
      return object().shape({
        translations: array().of(
          object().shape({
            name: string().required(message({ id: "requiredFieldError" })),
            description: string().nullable(),
          }),
        ),
        activity: object().shape({
          startsAt: string().required(message({ id: "requiredFieldError" })),
          endsAt: string().nullable(),
        }),
        labels: array().of(
          object().shape({
            key: string().required(message({ id: "requiredFieldError" })),
            value: string().required(message({ id: "requiredFieldError" })),
          }),
        ),
        visibility: object().shape({
          target: string().required(message({ id: "requiredFieldError" })),
          tiers: array()
            .of(string())
            .when("target", {
              is: "tier",
              then: (schema) =>
                schema
                  .min(1, message({ id: "requiredFieldError" }))
                  .required(message({ id: "requiredFieldError" })),
              otherwise: (schema) => schema.nullable(),
            }),
          segments: array()
            .of(string())
            .when("target", {
              is: "segment",
              then: (schema) =>
                schema
                  .min(1, message({ id: "requiredFieldError" }))
                  .required(message({ id: "requiredFieldError" })),
              otherwise: (schema) => schema.nullable(),
            }),
        }),
        displayOrder: number().nullable(),
      });
  }
};
